module.exports = __webpack_public_path__ + "static/media/reel-left-arrow-light.35764de6.svg";